import api from '../utils/api';

const notificationApi = {
  // ===== GENERAL NOTIFICATIONS =====
  
  // Get all notifications for current user
  getNotifications: async (options = {}) => {
    const {
      limit = 50,
      offset = 0,
      type = null,
      unreadOnly = false,
      includeDismissed = false
    } = options;

    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      unread_only: unreadOnly.toString(),
      include_dismissed: includeDismissed.toString()
    });

    if (type) {
      params.append('type', type);
    }

    const response = await api.get(`/notifications?${params}`);
    return response.data;
  },

  // Get unread notification count
  getUnreadCount: async () => {
    const response = await api.get('/notifications/count');
    return response.data;
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  // Dismiss notification
  dismissNotification: async (notificationId) => {
    const response = await api.put(`/notifications/${notificationId}/dismiss`);
    return response.data;
  },

  // Get specific notification
  getNotification: async (notificationId) => {
    const response = await api.get(`/notifications/${notificationId}`);
    return response.data;
  },

  // ===== MENTIONS SPECIFIC =====

  // Get all mentions (user and department)
  getAllMentions: async (options = {}) => {
    const {
      limit = 50,
      offset = 0,
      mentionType = 'all' // 'user', 'department', 'all'
    } = options;

    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      mention_type: mentionType
    });

    const response = await api.get(`/notifications/mentions/all?${params}`);
    return response.data;
  },

  // Get user mentions (direct @user mentions)
  getUserMentions: async (options = {}) => {
    const {
      limit = 50,
      offset = 0
    } = options;

    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString()
    });

    const response = await api.get(`/notifications/mentions/user?${params}`);
    return response.data;
  },

  // Get department mentions
  getDepartmentMentions: async (options = {}) => {
    const {
      limit = 50,
      offset = 0
    } = options;

    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString()
    });

    const response = await api.get(`/notifications/mentions/department?${params}`);
    return response.data;
  },

  // Get mention counts
  getMentionCounts: async () => {
    const response = await api.get('/notifications/mentions/counts');
    return response.data;
  }
};

export default notificationApi; 